module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "crew_right"
  }, [_c('div', {
    staticClass: "conInner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "lm-con"
  }, [_c('div', {
    staticClass: "inner"
  }, [(_vm.applyStatus == 2) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "msgbox"
  }, [_c('p', [_c('span', [_vm._v("店铺名称：" + _vm._s(_vm.leagueName))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("电话号码：" + _vm._s(_vm.tel))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("地址：" + _vm._s(_vm.attr))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("市场" + _vm._s(_vm.legionName))])]), _vm._v(" "), (_vm.status == 1 && _vm.notPassReason != '' && _vm.apply == 2) ? _c('p', [_c('span', [_vm._v("拒绝原因："), _c('em', [_vm._v("(" + _vm._s(_vm.notPassReason) + ")")])])]) : _vm._e()]), _vm._v(" "), (_vm.status == 1) ? _c('div', [_c('div', {
    staticClass: "msgbox border_b"
  }, [_c('p', [_vm._v("身份证照片（正反面）")]), _vm._v(" "), _c('div', {
    staticClass: "img_box id_box"
  }, _vm._l((_vm.idImg), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "demo-upload-list"
    }, [_c('img', {
      attrs: {
        "src": item
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.idImg),
        expression: "idImg"
      }],
      staticClass: "demo-upload-list-cover"
    }, [_c('Icon', {
      attrs: {
        "type": "ios-eye-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleView(item)
        }
      }
    })], 1)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "msgbox border_b"
  }, [_c('p', [_vm._v("营业执照照片")]), _vm._v(" "), _c('div', {
    staticClass: "img_box"
  }, _vm._l((_vm.licenseImg), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "demo-upload-list"
    }, [_c('img', {
      attrs: {
        "src": item
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.licenseImg),
        expression: "licenseImg"
      }],
      staticClass: "demo-upload-list-cover"
    }, [_c('Icon', {
      attrs: {
        "type": "ios-eye-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleView(item)
        }
      }
    })], 1)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "msgbox"
  }, [_c('p', [_vm._v("门头横幅照片（请横向拍摄）")]), _vm._v(" "), _c('div', {
    staticClass: "img_box"
  }, [_vm._l((_vm.storeBannerImg), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "demo-upload-list"
    }, [_c('img', {
      attrs: {
        "src": item
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "demo-upload-list-cover"
    }, [_c('Icon', {
      attrs: {
        "type": "ios-eye-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleView(item)
        }
      }
    }), _vm._v(" "), _c('Icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.apply != 0),
        expression: "apply != 0"
      }],
      attrs: {
        "type": "ios-trash-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleRemoveListBanner(index)
        }
      }
    })], 1)])
  }), _vm._v(" "), _c('Upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.apply != 0),
      expression: "apply != 0"
    }],
    staticStyle: {
      "display": "inline-block",
      "width": "150px"
    },
    attrs: {
      "show-upload-list": false,
      "before-upload": _vm.handleBeforeUpload,
      "on-exceeded-size": _vm.handleMaxSize,
      "on-success": _vm.handleSuccessListBanner,
      "on-format-error": _vm.handleFormatError,
      "format": ['jpg', 'jpeg', 'png'],
      "max-size": 2048,
      "headers": {
        "Auth-Token": _vm.upHeaders
      },
      "multiple": "",
      "type": "drag",
      "action": _vm.UploadUrl()
    }
  }, [_c('div', {
    staticStyle: {
      "width": "150px",
      "height": "150px",
      "line-height": "150px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-camera",
      "size": "40"
    }
  })], 1)])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "msgbox"
  }, [_c('p', [_vm._v("店面照片")]), _vm._v(" "), _c('div', {
    staticClass: "img_box"
  }, [_vm._l((_vm.shopImg), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "demo-upload-list"
    }, [_c('img', {
      attrs: {
        "src": item
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "demo-upload-list-cover"
    }, [_c('Icon', {
      attrs: {
        "type": "ios-eye-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleView(item)
        }
      }
    }), _vm._v(" "), _c('Icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.apply != 0),
        expression: "apply != 0"
      }],
      attrs: {
        "type": "ios-trash-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleRemoveListShop(index)
        }
      }
    })], 1)])
  }), _vm._v(" "), _c('Upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.apply != 0),
      expression: "apply != 0"
    }],
    staticStyle: {
      "display": "inline-block",
      "width": "150px"
    },
    attrs: {
      "show-upload-list": false,
      "on-exceeded-size": _vm.handleMaxSize,
      "on-success": _vm.handleSuccessListShop,
      "on-format-error": _vm.handleFormatError,
      "format": ['jpg', 'jpeg', 'png'],
      "max-size": 2048,
      "headers": {
        "Auth-Token": _vm.upHeaders
      },
      "multiple": "",
      "type": "drag",
      "action": _vm.UploadUrl()
    }
  }, [_c('div', {
    staticStyle: {
      "width": "150px",
      "height": "150px",
      "line-height": "150px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-camera",
      "size": "40"
    }
  })], 1)])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.apply != 0),
      expression: "apply != 0"
    }],
    staticClass: "regis_box"
  }, [_c('input', {
    staticClass: "regis_ent",
    attrs: {
      "type": "button",
      "value": "立即修改",
      "id": "editBtn"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit(0)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.apply == 0),
      expression: "apply == 0"
    }],
    staticClass: "regis_box"
  }, [_c('input', {
    staticClass: "regis_ent",
    attrs: {
      "type": "button",
      "value": "审核中"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "图片预览"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [(_vm.visible) ? _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.showImageUrl
    }
  }) : _vm._e()])], 1) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data"
  }, [_c('h2', [_vm._v("补充我的资料")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06629e5f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/my-data/right/editLeague.vue
// module id = 1520
// module chunks = 1